import * as React from 'react'
import { ReactElement } from 'react'
import { Currency } from '../../../config/i18nConfig'
import useCurrencies from '../../../hooks/useCurrencies'
import I18NCombobox, { I18NComboboxProps } from './I18NCombobox'

export type CurrencyComboboxProps = Omit<I18NComboboxProps<Currency>, 'entities' | 'idKey'>

export default function CurrencyCombobox(props: CurrencyComboboxProps): ReactElement {
    const { currencies } = useCurrencies()

    return (
        <I18NCombobox<Currency>
            entities={currencies}
            idKey={'alpha'}
            placeholderKey={'base.currencycombobox.placeholder'}
            {...props}
        />
    )
}
